module.exports = __webpack_public_path__ + "b55b7bd468771dbf4a1ec983bc70c677.jpg";